import { Outlet } from 'react-router-dom';
import AppBar from './AppBar';
import BottomNav from './BottomNav';
import SideNav from './SideNav';

export default function AppShell() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-950 dark:bg-[#080c14] dark:text-slate-100">
      <AppBar />
      <div className="flex min-h-[calc(100vh-3.5rem)]">
        <SideNav />
        <main className="flex-1 min-w-0 pb-24 md:pb-10">
          <div className="mx-auto max-w-[1400px] px-3 md:px-8 py-5 md:py-8">
            <Outlet />
          </div>
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
